import Navbar from './components/Navbar';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import LenisScroll from './LenisScroll';
import Intro from './components/Intro';

function App() {
  return (
    <div className="bg-white text-black transition-all duration-300">
      <LenisScroll />
      <Navbar />
      <Intro />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
